import c from "class-c";

import createPropsProvider from "@repo/utils-solid/createPropsProvider";

import styles from "./MapLocation.module.scss";

declare namespace MapLocation {
  type Props = {
    class?: string;
    apiKey?: string;
    query: string;
  };
}

function MapLocation(_props: MapLocation.Props) {
  const {
    apiKey,
    class: className,
    query,
  } = MapLocation.PropsProvider.useMerge(_props) satisfies D;

  return (
    <div class={c`${styles["map-location"]} ${className}`}>
      {query !== "-" && (
        <iframe
          width="100%"
          height="360"
          style="border:0"
          loading="lazy"
          allowfullscreen
          referrerpolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${query}`}
        />
      )}
    </div>
  );
}

MapLocation.PropsProvider =
  createPropsProvider<MapLocation.Props>("MapLocation");

export default MapLocation;
